import { ReactNode, useEffect, useRef, useState } from "react";
// @mui
import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  CardProps,
  TableContainer,
  useTheme,
  alpha,
} from "@mui/material";
// components

import Scrollbar from "../../components/scrollbar/Scrollbar";
import { TableHeadCustom } from "../../components/table";
import { useLocales } from "@/locales";
// import useResize from "@/hooks/useResize";

type RowProps = {
  /** 参数名 */
  name?: string;
  /** 规则 */
  rule?: string;
  /** 参数类型 */
  type?: string;
  /** 是否必填 */
  is_?: string;
  /** 参数描述 */
  desc: ReactNode;
  [key: string]: any;
};
interface Props extends CardProps {
  /** 是否为空 默认为false */
  isEmpty?: boolean;
  /** 为空时的提示文本 */
  isEmptyText?: ReactNode;
  /** 默认是请求参数示例表格  res为true不显示 默认显示 */
  res?: boolean;
  /** 是否显示name 默认为true */
  showName?: boolean;
  /** 是否显示type 默认为true */
  showType?: boolean;
  /** 是否显示参数描述 默认为true */
  showDesc?: boolean;
  /** 是否显示规则 默认不显示 */
  showRule?: boolean;
  tableData: RowProps[];
}
export default function ParamsTable({
  tableData,
  res = false,
  showName = true,
  showType = true,
  showDesc = true,
  showRule = false,
  isEmpty = false,
  isEmptyText = "",
  ...other
}: Props) {
  const { translate } = useLocales();
  const theme = useTheme();

  const tableLabels: { id: string; label: string; isFixed?: boolean }[] = [
    ...(!showName
      ? []
      : [{ id: "name", label: translate("common.http_name") }]),
    ...(!showType
      ? []
      : [{ id: "type", label: translate("common.http_type") }]),
    ...(!showRule
      ? []
      : [{ id: "rule", label: translate("common.http_rule") }]),
    ...(res
      ? []
      : [{ id: "is_", label: translate("common.http_is_required") }]),
    ...(!showDesc
      ? []
      : [{ id: "desc", label: translate("common.http_desc") }]),
  ];

  const [isFixed, setIsFixed] = useState(false);

  const srcollRef = useRef<any>(null);

  // const reSize = useResize(({ width, height }) => {
  //   let scrollable = document.getElementById("scrollable");
  //   if (scrollable) {
  //     if (width < scrollable.scrollWidth) {
  //       setIsFixed(true);
  //     } else {
  //       setIsFixed(false);
  //     }
  //   }
  // }, 0);

  // useEffect(() => {
  //   const scrollcon = document.getElementById("scrol_table");
  //   if (scrollcon) {
  //     reSize(scrollcon as HTMLDivElement);
  //   }
  // }, [reSize]);

  useEffect(() => {
    // var scrollable = document.getElementById("scrollable");
    const scrollable = srcollRef.current;

    function scroll(e: any) {
      if (
        e.target.scrollLeft + e.target.clientWidth <
        e.target.scrollWidth - 10
      ) {
        console.log({
          scrollLeft: e.target.scrollLeft,
          b: e.target.clientWidth,
          c: e.target.scrollWidth,
        });
        setIsFixed(true);
      }

      if (e.target.scrollLeft >= 0 && e.target.scrollLeft <= 10) {
        setIsFixed(false);
        // console.log({
        //   scrollLeft: e.target.scrollLeft,
        //   b: e.target.clientWidth,
        //   c: e.target.scrollWidth,
        // });
      }
    }

    if (scrollable?.contentWrapperEl) {
      // console.log({ a: scrollable?.contentWrapperEl });

      scrollable.contentWrapperEl.addEventListener("scroll", scroll);
    }
    return () =>
      scrollable?.contentWrapperEl.removeEventListener("scroll", scroll);
  }, []);

  return (
    <Box
      {...other}
      sx={{
        // borderRadius: "0px 0px 16px 16px",
        borderLeft: isFixed ? `1px solid ${theme.palette.text.stroke}` : "none",
      }}
    >
      {/* id={"scrol_table"} */}
      <TableContainer sx={{ overflow: "unset" }}>
        {/* id={"scrollable"} */}
        <Scrollbar ref={srcollRef} className="action">
          <Table
            sx={{
              minWidth: 720,
              // border: `1px solid ${theme.palette.text.stroke}`,
              "& .MuiTableRow-root": {
                border: `1px solid ${theme.palette.text.stroke}`,
              },
            }}
          >
            <TableHeadCustom
              headLabel={tableLabels.map((tableLabel, i) => {
                const item = { ...tableLabel };
                if (showName && i === 0) {
                  item.isFixed = isFixed;
                }
                return item;
              })}
              sx={{
                "& .MuiTableCell-root": {
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? theme.palette.grey[100]
                      : theme.palette.grey[900],
                  color: theme.palette.text.secondary,
                  fontWeight: 400,
                  fontSize: "14px",
                  letterSpacing: "0.1px",
                  lineHeight: "24px",
                  borderRight: `1px solid ${theme.palette.text.stroke}`,
                },
              }}
            />

            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  backgroundColor:
                    theme.palette.mode === "light"
                      ? theme.palette.grey[0]
                      : theme.palette.grey[900],
                  color: theme.palette.text.primary,
                  fontWeight: 400,
                  fontSize: "14px",
                  letterSpacing: "0.1px",
                  borderRight: `1px solid ${theme.palette.text.stroke}`,
                },
              }}
            >
              {isEmpty ? (
                <EmptyRow showText={isEmptyText} />
              ) : (
                <>
                  {tableData.map((row, i) => (
                    <ParamsTableRow key={i} row={row} isFixed={isFixed} />
                  ))}
                </>
              )}
            </TableBody>
          </Table>
        </Scrollbar>
      </TableContainer>
    </Box>
  );
}

type TableRowProps = {
  row: RowProps;
  isFixed: boolean;
};

const EmptyRow = ({ showText }: { showText: ReactNode }) => {
  return (
    <TableRow>
      <TableCell colSpan={12}>{showText}</TableCell>
    </TableRow>
  );
};

function ParamsTableRow({ row, isFixed }: TableRowProps) {
  const theme = useTheme();
  return (
    <>
      <TableRow
        sx={{
          "&:hover": {
            td: {
              backgroundColor: "#F3F3F4",
            },
          },
        }}
      >
        {row?.name && (
          <TableCell
            className={`${isFixed ? "cell-fixed" : ""}`}
            sx={{
              backgroundColor: isFixed
                ? theme.palette.background.default
                : theme.palette.mode === "light"
                ? theme.palette.grey[0]
                : theme.palette.grey[900],
              borderLeft: isFixed
                ? `1px solid ${theme.palette.text.stroke}`
                : "none",
              // minWidth: 160,
            }}
            key={row.name}
          >
            {row.name}
          </TableCell>
        )}

        {row?.type && (
          <TableCell
            sx={
              {
                // minWidth: 180,
              }
            }
          >
            {row.type}
          </TableCell>
        )}

        {row?.rule && (
          <TableCell
            sx={
              {
                // minWidth: 180,
              }
            }
          >
            {row.rule}
          </TableCell>
        )}

        {row?.is_ && (
          <TableCell
            sx={
              {
                // minWidth: 120,
                // maxWidth: 120,
              }
            }
          >
            {row.is_}
          </TableCell>
        )}

        {row?.desc && (
          <TableCell
            sx={{
              whiteSpace: "pre-wrap",
              code: {
                backgroundColor: alpha(theme.palette.grey[500], 0.1),
                padding: "2px 4px",
                color: theme.palette.text.primary,
              },
            }}
          >
            {row.desc}
          </TableCell>
        )}
      </TableRow>
    </>
  );
}
